export default "__VITE_ASSET__tFrgHbSz__"